import { render } from "./Clinic.vue?vue&type=template&id=7a4660e5&scoped=true"
import script from "./Clinic.vue?vue&type=script&lang=js"
export * from "./Clinic.vue?vue&type=script&lang=js"

import "./Clinic.vue?vue&type=style&index=0&id=7a4660e5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a4660e5"],['__file',"src/views/clinic/Clinic.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7a4660e5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7a4660e5', __exports__)) {
    api.reload('7a4660e5', __exports__)
  }
  
  module.hot.accept("./Clinic.vue?vue&type=template&id=7a4660e5&scoped=true", () => {
    api.rerender('7a4660e5', render)
  })

}


export default __exports__